import {Stack, Typography} from "@mui/material";
import {Navigate, useParams} from "react-router";
import {appSession} from "../../../TR3AD.ts";
import WidgetHeader from "../../../widgets/WidgetHeader.tsx";
import {appStyles} from "../../../AppStyles.ts";

function UXResearcherCreate() {
    const {networkUID} = useParams();

    return (
        <Stack direction="column" width="100%" minHeight="100vh">
            {!appSession.activeSession() ? (
                <Navigate to="/" />
            ) : (
                <Stack direction="column" spacing={1} width="99%">
                    <WidgetHeader
                        title="Create Researcher"
                        breadcrumbs={[
                            {display: "Networks", linkTo: "/networks/", activeView: false},
                            {display: String(networkUID), linkTo: `/networks/${networkUID}`, activeView: false},
                            {display: "Researchers", linkTo: `/networks/${networkUID}/research`, activeView: false},
                            {display: "Create", linkTo: "", activeView: true},
                        ]}
                    />
                    <Stack sx={appStyles.sectionBox} spacing={0} width="100%" alignItems="center">
                        <Typography sx={{...appStyles.panelSectionTitle, padding: "16px 0 8px"}}>
                            Create Researcher
                        </Typography>
                        <Typography sx={{color: "rgba(242, 245, 250, 0.5)", fontSize: "0.85rem", padding: "48px 24px", textAlign: "center"}}>
                            Create form will be built out in a future session.
                        </Typography>
                    </Stack>
                </Stack>
            )}
        </Stack>
    );
}

export default UXResearcherCreate;
